<template>
    <div class="float-container--bottom">
        <button class="btn btn-cancel btn-lg btn-heavy" @click="OnChangeToAvailable">
            <span v-if="settings && settings.invertir_movil_libre_no_disponible" v-lang.movilLibre>Móvil libre</span>
            <span v-else v-lang.noDisponible>No disponible</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'driverUnavailable',
    props: [

    ],
    data () {
        return {
            price: ''
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            settings: 'company/config',
            currentPosition: 'geolocation/actual'
        })
    },
    mounted () {
        this.language = this.$getLang();
    },

    methods: {
        ...mapActions({
            changeAvailability: 'driver/changeAvailability'
        }),
        OnChangeToAvailable () {
            this.changeAvailability(true);
        }

    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/driver/OnUnvailable.vue